import { useState } from "react";
import { Button, Paper, Typography } from "@mui/material"
import AddIcon from '@mui/icons-material/Add';
import dayjs from 'dayjs';

import { GuardedComponent } from "../../../components/guarded-component"
import { SiTrackPage } from "../../../components/si-track-page"
import { UserPermissionName } from "../../../models/user-permission-name";
import { SiTrackGrid } from "../../../components/si-track-grid/si-track-grid";
import { holidayManagementColumns } from "./grid-columns";
import { holidayManagementApiKeyStore } from "../../../api/masters/holiday-management-api-key-store";
import { SaveHookFormDialog } from "../../../components/save-hook-form.dialog";
import { HolidayForm } from "./holiday.form";
import { holidayFormSchema } from "./holiday-form.schema";

interface CellProps {
    holidayData: any;
}

interface CustomGridCellProps {
    field: string;
}

const styling = {
    paperStyle: { padding: '20px', borderRadius: '20px' },
};

export const HolidayManagementPage = () => {

    const [editItem, setEditItem] = useState<Partial<any>>();

    const handleEditHoliday = (holidayData: any) => {
        setEditItem(holidayData);
    };
    const handleEditClose = () => {
        setEditItem(undefined);
    };
    const handleCreateHoliday = () => {
        setEditItem({ year: "", isActive: true });
    };

    const formatSubmitdata = (data: any) => {
        const formattedDate = dayjs(data.holidayDate).format("MM/DD/YYYY");
        return {
            ...data,
            holidayDate: formattedDate,
        };
    };

    const PlanStatusCell = ({ holidayData }: CellProps) => {
        const status = holidayData?.isActive;
        return (
            <td>
                <Typography component="span">{status ? "Active" : "Inactive"}</Typography>
            </td >
        );
    };

    const CustomGridCell = ({ field }: CustomGridCellProps) => {
        if (field === 'isActive') {
            return (dataItem: any) => {
                return <PlanStatusCell holidayData={dataItem.dataItem} />;
            };
        }
    }

    return (
        <SiTrackPage
            title="Holiday Management"
            actionButton={
                <GuardedComponent requiredPermissions={[UserPermissionName.ADD_HOLIDAY]}>
                    <Button
                        size="small"
                        variant="contained"
                        disableElevation={true}
                        startIcon={<AddIcon />}
                        onClick={handleCreateHoliday}
                    >
                        Add Holiday
                    </Button>
                </GuardedComponent>
            }
        >
            <Paper elevation={0} style={styling.paperStyle}>
                <SiTrackGrid
                    fileTitle='holiday'
                    dataItemKey="holidayID"
                    columns={holidayManagementColumns}
                    queryConfig={holidayManagementApiKeyStore.getHolidays()}
                    onEdit={handleEditHoliday}
                    customCell={(field) =>
                        CustomGridCell({
                            field,
                        })
                    }
                    deleteMutationConfig={(deleteItem) => holidayManagementApiKeyStore.deleteHoliday(deleteItem.holidayID)}
                    actionPermissions={{
                        edit: UserPermissionName.EDIT_HOLIDAY,
                        delete: UserPermissionName.DELETE_HOLIDAY,
                        export: UserPermissionName.DOWNLOAD_GRID,
                    }}
                />
                {editItem && (
                    <SaveHookFormDialog
                        title={editItem.holidayID ? 'UPDATE HOLIDAY' : 'CREATE HOLIDAY'}
                        config={{
                            saveConfig: editItem.holidayID
                                ? holidayManagementApiKeyStore.updateHoliday()
                                : holidayManagementApiKeyStore.createHoliday(),
                            invalidateRoute: () => holidayManagementApiKeyStore.getHolidays(),
                        }}
                        data={editItem}
                        yupSchema={holidayFormSchema}
                        formatSubmitdata={formatSubmitdata}
                        onClose={handleEditClose}
                        size="xs"
                    >
                        <HolidayForm editItem={editItem} />
                    </SaveHookFormDialog>
                )}
            </Paper>
        </SiTrackPage>
    )
}